import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Instagram, Mail, ArrowUp } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Pillars } from "@/components/sections/Pillars";
import { Metrics } from "@/components/sections/Metrics";
import { Demographics } from "@/components/sections/Demographics";
import { Portfolio } from "@/components/sections/Portfolio";
import { Contact } from "@/components/sections/Contact";
import Inbox from "@/pages/Inbox";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t-[3px] border-clay-ink bg-clay-ink px-4 py-12 text-white sm:px-6">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
      <div>
        <p className="font-display text-3xl font-black tracking-tighter">
          Himangini Singh Rathore
        </p>
        <p className="mt-1 font-body text-sm text-white/60">
          Beauty · Lifestyle · Medicine — Media Kit {new Date().getFullYear()}
        </p>
      </div>
      <div className="flex items-center gap-3">
        <a
          href="https://instagram.com/hi._.manganese"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="flex h-11 w-11 items-center justify-center rounded-full border-[3px] border-white/30 transition-colors hover:bg-clay-violet"
        >
          <Instagram className="h-5 w-5" strokeWidth={2.25} />
        </a>
        <a
          href="mailto:himanginisingh.2002@gmail.com"
          data-testid="footer-email"
          className="flex h-11 w-11 items-center justify-center rounded-full border-[3px] border-white/30 transition-colors hover:bg-clay-violet"
        >
          <Mail className="h-5 w-5" strokeWidth={2.25} />
        </a>
        <a
          href="#top"
          data-testid="footer-top"
          className="flex h-11 w-11 items-center justify-center rounded-full border-[3px] border-clay-lime bg-clay-lime text-clay-ink"
        >
          <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
        </a>
      </div>
    </div>
  </footer>
);

function MediaKit() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App relative min-h-screen overflow-x-hidden bg-clay-bg font-body text-clay-ink">
        <div className="noise-overlay" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Pillars />
          <Metrics />
          <Demographics />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MediaKit />} />
        <Route path="/inbox" element={<Inbox />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
